import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";
export const StyledPaginationComponent = styled.div`
  display: flex;
  flex-direction: column;

  .show-more-btn {
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    text-decoration: none;
  }

  .pagination {
    display: flex;
    padding: 0;
    justify-content: space-around;

    .pagination-list {
      display: flex;
      list-style: none;
      padding: 0;

      .pagination-link-container {
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        font-size: 0.75rem;
        border-radius: 2px;
        margin: 0 4px;
        min-width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.prev {
          margin-left: 0;
        }

        &.is-current {
          background-color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
          color: white;
        }

        .pagination-link {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 8px;
          width: 100%;
          height: 100%;
          text-decoration: none;
          color: inherit;

          &.is-disabled {
            cursor: not-allowed;
            pointer-events: none;
            opacity: 0.5;
          }
        }
      }

      .pagination-ellipsis {
        margin: 0 0.5em;
      }
    }
  }
`;
